import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CssVariablesService {
  // the idea was taken from the https://gist.github.com/luciopaiva/01bda0d4311ccaecea0478ad2fd03108 and the https://stackoverflow.com/a/54470889

  constructor() {}

  readCssVar(varName, doc = document, win = window) {
    varName = varName.startsWith('--') ? varName : '--' + varName;
    return win.getComputedStyle(doc.documentElement).getPropertyValue(varName);
  }

  readCssVarAsNumber(varName) {
    return parseInt(this.readCssVar(varName), 10);
  }

  readCalculatedCssVarAsNumber(varName, doc = document, win = window) {
    let div = doc.getElementById('readCalculatedCssVarAsNumber');
    if (!div) {
      div = doc.createElement('div');
      div.setAttribute('id', 'readCalculatedCssVarAsNumber');
      div.setAttribute('position', 'absolute'); // detach it from the flow so it doesn't break anything
      doc.body.appendChild(div); // won't work unless you actually append it to the DOM
    }
    div.style.strokeWidth = this.readCssVar(varName); // apply it to some innocent property
    return parseInt(getComputedStyle(div).getPropertyValue('stroke-width'), 10); // read it back!
  }

  writeCssVar(varName, value, doc = document) {
    varName = varName.startsWith('--') ? varName : '--' + varName;
    doc.documentElement.style.setProperty(varName, value);
  }

  getAllCssVarNames(doc = document, win = window) {
    let cssVars = [];
    // loop each stylesheet
    for (let i = 0; i < doc.styleSheets.length; i++) {
      // loop stylesheet's cssRules
      try {
        // try/catch used because 'hasOwnProperty' doesn't work
        for (let j = 0; j < doc.styleSheets[i].cssRules.length; j++) {
          try {
            // loop stylesheet's cssRules' style (property names)
            for (let k = 0; k < doc.styleSheets[i].cssRules[j]['style'].length; k++) {
              let name = doc.styleSheets[i].cssRules[j]['style'][k];
              // test name for css variable signature and uniqueness
              if (name.startsWith('--') && cssVars.indexOf(name) == -1) {
                cssVars.push(name);
              }
            }
          } catch (error) {}
        }
      } catch (error) {}
    }

    return cssVars;
  }

  getElementCssVars(allCSSVars, pseudo = null, doc = document, win = window) {
    let elStyles = win.getComputedStyle(doc.body, pseudo);
    let cssVars = {};

    for (let i = 0; i < allCSSVars.length; i++) {
      let key = allCSSVars[i];
      let value = elStyles.getPropertyValue(key);
      if (value) {
        cssVars[key] = value;
      }
    }

    return cssVars;
  }

  injectAllCssVarsToDocument(doc = document, win = window) {
    const cssVarsNames = this.getAllCssVarNames();
    const cssVars = this.getElementCssVars(cssVarsNames);

    Object.keys(cssVars).forEach((varName) => {
      this.writeCssVar(varName, cssVars[varName], doc);
    });
  }
}
